<template>
  <footer class="block-footer">
    <div class="block-footer__container">
      <a
        class="block-footer__disclamer-switch"
        href="#"
        @click.prevent="show_conditions = !show_conditions"
      >
        Полные условия акции
      </a>
      <div
        class="block-footer__disclamer block-footer__disclamer--open-anim"
        v-show="show_conditions"
      >
        <br />*Предложение не является публичной офертой, предложение ограничено
        и действует с {{ disc_start_date }}г. по {{ disc_end_date }}г.

        <br /><br />Полные условия акции можно уточнить у
        продавцов-консультантов дилерского центра РОЛЬФ по телефону
        <a href="tel:84957851994">+7 495 785‑19‑94</a>.

        <br /><br />Авторассрочка распространяется на покупку нового автомобиля
        Mitsubishi и предоставляется банком-партнером Совкомбанк. Процентная
        ставка 0% действует при покупке автомобиля в рассрочку сроком на 12, 18
        или 24 месяца. Оформление рассрочки 0% возможно без первоначального
        взноса на автомобиль. Обязательным условием при покупке автомобиля в
        рассрочку является открытие карты "Халва". Для сохранения условий
        рассрочки 0% необходимо совершать покупки по данной карте на сумму не
        менее 10 000р. в месяц, и совершении не менее 5 покупок в месяц.
        Предложение не является публичной офертой. Подробности по телефону
        дилерских центров РОЛЬФ <a href="tel:84957851994">+7 495 785‑19‑94</a>.

        <br /><br />***РОЛЬФ признан лучшим автомобильным холдингом по версии
        Аналитического агентства «АВТОСТАТ» в Национальной премии «АВТОДИЛЕР
        ГОДА» в номинации "Организация продаж: Новые автомобили"

        <br /><br />Данный сайт носит исключительно информационно-справочный
        характер, не является публичной офертой.

        <br /><br />Подробности акции по телефону
        <a href="tel:84957851994">+7 495 785‑19‑94</a>
        и в дилерском центре РОЛЬФ.
      </div>
    </div>
    <div class="containers" style="pointer-events: none">
      <iframe
        src="https://yandex.ru/sprav/widget/rating-badge/20140849335"
        width="150"
        height="50"
        frameborder="0"
      ></iframe>
    </div>
    <div class="yur-info">
      <p>АО «РОЛЬФ»</p>
      <p>
        Юридический адрес: 141410, Россия, Московская область, г. Химки,
        Ленинградское шоссе, владение №21
      </p>
      <p>ИНН: 5047254063</p>
      <p>ОГРН: 1215000076279</p>
      <p
        class="politic-text"
        @click="$root.$emit('get-agreement')"
      >Условия обработки персональных данных</p>
    </div>
    <div class="timer" ref="timer"></div>
  </footer>
</template>

<script>
import Mixin from '../common/mixin';

export default {
  mixins: [Mixin],
  data() {
    return {
      show_conditions: false,
      CONSTANTS: this.CONSTANTS,
    };
  },
  computed: {
    today() {
      return new Date();
    },
    lastDay() {
      return new Date(this.today.getFullYear(), this.today.getMonth() + 1, 0);
    },
    disc_start_date() {
      return `01.${
        +this.today.getMonth() + 1 < 10 ? "0" : ""
      }${this.today.getMonth() + 1}.${this.today.getFullYear()}`;
    },
    disc_end_date() {
      return `${this.lastDay.getDate()}.${
        +this.today.getMonth() + 1 < 10 ? "0" : ""
      }${this.today.getMonth() + 1}.${this.today.getFullYear()}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.politic-text {
  text-decoration: underline;
  cursor: pointer;
}

@keyframes conditions-show {
  from {
    opacity: 0;
    height: 0;
  }

  90% {
    opacity: 1;
    height: 200px;
  }

  to {
    height: auto;
  }
}

@keyframes conditions-close {
  from {
    height: 200px;
    opacity: 1;
  }

  to {
    height: 0;
    opacity: 0;
  }
}

.containers {
  margin: 0px auto;
  max-width: 1140px;
  position: relative;
  padding: 0px 15px;
}

.yur-info {
  font-size: 14px;
  text-align: center;

  & p {
    margin: 0;
  }
}

.block-footer {
  padding-bottom: 10px;
  &__container {
    margin: 0px auto;
    max-width: 1140px;
    position: relative;
    padding: 0px 15px;
    text-align: center;
  }

  &__disclamer {
    display: block;

    font-size: 10px;
    text-align: left;
    color: black;
    padding-bottom: 20px;

    &--open-anim {
      animation-name: conditions-show;
      animation-duration: 0.5s;
    }

    &--close-anim {
      animation-name: conditions-close;
      animation-duration: 0.5s;
    }
  }

  &__disclamer-switch {
    color: black;
    text-decoration: underline;
    font-size: 12px;
    line-height: 100%;
    display: inline-block;
    text-decoration: underline;
    padding-top: 30px;
    margin-bottom: 20px;
  }
}
</style>
